import React from 'react'
import { Grid, Container, Typography, CircularProgress, useTheme, useMediaQuery } from '@material-ui/core'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { Link, useLocation } from 'react-router-dom'
import { useStore } from '../../context/Context'
import useStyles from './styles'

import CardMovies from './CardMovies/CardMovies'

const ListMovies = () => {
  const classes = useStyles()
  const location = useLocation()
  const theme = useTheme()
  const matchSM = useMediaQuery(theme.breakpoints.down('sm'))
  const moviesEndpoint = location.pathname === '/movies'
  const { listMovies, isLoading, setSelectedTab, isLogin } = useStore()
  const listMoviesMap = moviesEndpoint ? listMovies : isLogin ? listMovies.slice(0, 6) : listMovies.slice(0, 4)

  if (isLoading) return (
    <Grid container justifyContent="center" alignItems="center" className={classes.loading}>
      <CircularProgress />
    </Grid>
  )

  return (
    <main className={classes.root}>
      <Container>
        <Grid container direction="column">
          <Grid item container justifyContent="space-between" alignItems="center">
            <Grid item container={moviesEndpoint && matchSM} justifyContent={moviesEndpoint && matchSM ? 'center' : undefined}>
              <Grid item>
                <Typography variant="h5" color="textSecondary" className={classes.title}>{moviesEndpoint ? 'Movies List' : 'Latest Movies'}</Typography>
              </Grid>
            </Grid>
            {(listMovies.length > 4 && location.pathname !== '/movies') && (
              <Grid item>
                <Grid item container alignItems="center" component={Link} to="#" className={classes.link}>
                  <Typography variant="caption" onClick={() => window.location.href = '/movies'}>View More</Typography>
                  <ChevronRightIcon />
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid item container className={classes.cardContainer} justifyContent={matchSM ? 'center' : 'flex-start'} spacing={3}>
            {listMoviesMap.map(movie => (
              <Grid item key={movie.id}>
                <CardMovies
                  key={movie.id}
                  title={movie.title}
                  year={movie.year}
                  media={movie.image_url}
                  genre={movie.genre}
                  rating={movie.rating}
                  duration={movie.duration}
                  onClick={() => {
                    setSelectedTab(false)
                    window.location.href = "/showMovie/" + movie.id
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </main>
  )
}

export default ListMovies
